import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcelInmuebles = (data, fileName = "inmuebles.xlsx") => {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar");
        return;
    }

    const exportData = data.map(item => ({
        Nombre: item.name,
        Tipo: item.type,
        Direccion: item.address,
        Hipoteca: item.isMortgaged ? "Hipotecado" : "No hipotecado",
        Renta: item.isRented ? "Rentado" : "No rentado",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    ws['!cols'] = [
        { wch: 25 },
        { wch: 15 },
        { wch: 40 },
        { wch: 20 },
        { wch: 20 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inmuebles");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, fileName);
};
